import React, { Component, Fragment } from "react";
import { Share2, Eye, Users, UserPlus } from "react-feather";

const Icons = {
  CONTENT_SHARED: <Share2 size={16} />,
  CONTENT_VISITED: <Eye size={16} />,
  MEETING_INVITED: <UserPlus size={16} />,
  MEETING_ATTENDED: <Users size={16} />,
}

class ContentActivity extends Component {
  state = {};

  getColor = (action) => {
    switch (action) {
      case "CONTENT_VISITED":
        return "green";
      case "CONTENT_SHARED":
        return "#FFDF00";
      case "MEETING_ATTENDED":
        return "red";
      case "MEETING_INVITED":
        return "#7769f7";
      default:
        return "#eee"
    }
  }

  getText = (action) => {
    switch (action) {
      case "CONTENT_VISITED":
        return "Saw Document";
      case "CONTENT_SHARED":
        return "Shared Document";
      case "MEETING_ATTENDED":
        return "Attended Meeting";
      case "MEETING_INVITED":
        return "Invited for Meeting";
      default:
        return ""
    }
  }

  visitText = (act) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{this.getText(act.activityType)}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{act.content.title}</u></span> for&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{act.content.duration}</span>
      </p>
    )
  }

  shareText = (act) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{this.getText(act.activityType)}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{act.content.title}</u></span> via&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{act.channel}</span>
      </p>
    )
  }

  attendedText = (act) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{this.getText(act.activityType)}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{act.meeting.title}</u></span> for&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{act.meeting.duration} mins</span>
      </p>
    )
  }

  inviteText = (act) => {
    return (
      <p>
        <span className="font-weight-bold mb-0 text-capitalize">{this.getText(act.activityType)}&nbsp;</span>
        <span className="font-small-6 font-weight-normal"><u>{act.content.title}</u></span> on&nbsp;
        <span className="font-weight-bold mb-0 text-capitalize">{act.invitedOn}, {act.invitedOn}</span>
      </p>
    )
  }

  getActivityInfo = (act) => {
    const { activityType } = act;
    switch (activityType) {
      case "CONTENT_VISITED":
        return this.visitText(act);
      case "CONTENT_SHARED":
        return this.shareText(act);
      case "MEETING_ATTENDED":
        return this.attendedText(act);
      case "MEETING_INVITED":
        return this.inviteText(act);
      default:
        return "--NA--";
    }
  }

  render(){
    const { activities } = this.props;
    return (
      <Fragment>
        <ul className="activity-timeline timeline-left list-unstyled">
          {
            activities && activities.length > 0 ? activities.map((act, index) => {
              return (
                <li key={index} >
                  <div className="timeline-icon" style={{ backgroundColor: `${this.getColor(act.activityType)}` }}>
                    {Icons[act.activityType]}
                  </div>
                  <div className="timeline-info">
                    {this.getActivityInfo(act)}
                  </div>
                  <small className="text-muted">{this.getText(act.activityType)}</small>
                </li>
              )
            }) : <div>No Activities Found</div>
          }
        </ul>
        {
          activities && activities.length > 0 && <div className="text-center">
            <span style={{ color: "#7769f7", cursor: "pointer" }}>Load More</span>
          </div>
        }
      </Fragment>
    );
  }


}

export default ContentActivity;